import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const playerAvatar = (name) =>
  `https://api.dicebear.com/9.x/notionists/svg?seed=${encodeURIComponent(name || "jugador")}&backgroundColor=1a2a6c`;

export function PlayerCard({ player, i = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: Math.min(i * 0.06, 0.3) }}
    >
      <Link
        to={`/jugador/${player.slug}`}
        data-testid={`player-card-${player.slug}`}
        className="group relative block aspect-[3/4] rounded-2xl overflow-hidden border border-gray-100 shadow-sm bg-navy"
      >
        <img
          src={player.photo_url || playerAvatar(player.name)}
          alt={player.name}
          loading="lazy"
          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = playerAvatar(player.name); }}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {player.number && (
          <span className="absolute top-3 right-3 z-10 h-9 w-9 rounded-full bg-gold text-navy text-sm font-extrabold flex items-center justify-center shadow-md" style={{ fontFamily: "Outfit" }}>
            {player.number}
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-navy via-navy/85 to-transparent pt-20">
          {player.position && <p className="text-xs font-bold uppercase tracking-wider text-gold drop-shadow">{player.position}</p>}
          <h3 className="text-lg font-bold text-white leading-tight drop-shadow-md" style={{ fontFamily: "Outfit" }}>{player.name}</h3>
        </div>
        <span className="absolute top-3 left-3 z-10 h-9 w-9 rounded-full bg-white/0 group-hover:bg-white/15 backdrop-blur-sm flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-all">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </Link>
    </motion.div>
  );
}
